import "./AnnouncementBar.css";

const MESSAGE =
  "Beware of fraud! Always use our secure Repayment on Website Link for loan payments. Do not make direct bank payments to fake UPI links or unauthorised payment links. The EMI Saathi is not responsible for payments made to other accounts.";

const AnnouncementBar = () => {
  return (
    <div className="announcement-bar" role="marquee">
      <div className="announcement-bar__track">
        {[0, 1].map((copy) => (
          <div className="announcement-bar__item font-['Inter'] font-[500]" key={copy} aria-hidden={copy === 1}>
            <span className="announcement-bar__dot">●</span>
            {MESSAGE}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnnouncementBar;
